import { signInAnonymously } from 'firebase/auth'
import { auth } from '../firebase'

let pendingAnonymousSignIn = null

export default async function ensureSurveyFirebaseSession() {
  if (auth.currentUser) return auth.currentUser

  if (!pendingAnonymousSignIn) {
    pendingAnonymousSignIn = signInAnonymously(auth)
      .then((credential) => credential.user)
      .finally(() => {
        pendingAnonymousSignIn = null
      })
  }

  return pendingAnonymousSignIn
}
